import { render, staticRenderFns } from "./RecapSection.vue?vue&type=template&id=9173eba0&"
import script from "./RecapSection.vue?vue&type=script&lang=js&"
export * from "./RecapSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports